module.exports = __webpack_public_path__ + "img/chevron-up.dc2ef81b.svg";